import axiosInstance from '../utils/axios';
import { TransactionOwnershipType } from "../@types/transactions";

const EXTEND_URL = '/data-export/purchases/v1/';

export type GetPurchasesQueryParams = {
  ownershipType: TransactionOwnershipType | TransactionOwnershipType[],
  merchantCode: string | undefined,
  page: number,
  size: number,
  dateFrom?: string,
  dateTo?: string,
  email?: string,
  fields?: string[]
}

function exportPurchases(params: GetPurchasesQueryParams) {
  return axiosInstance.get(
    `${EXTEND_URL}`,
    { params,responseType: 'blob', paramsSerializer: { indexes: null } }
  );
}


export {
  exportPurchases
};
